<div *ngIf="loader" id="spinerLoader" class="container">
    <div class="loader">Loading...</div>
</div>

<div class="footerPosition">
    <section class="content-header row">
        <div class="col-sm-12">
            <h1 class="box-title">
                <strong>Messages</strong>
                <span class="ml-3">
                    <span class="text-danger count-badge count-font position-absolute">
                        <span *ngIf="!totalMessageCountLoader">
                            {{ totalMessageCount }}
                        </span>
                        <span *ngIf="totalMessageCountLoader">
                            <i class="fa fa-spin fa-spinner text-danger"></i>
                        </span>
                    </span>
                </span>
            </h1>
        </div>
    </section>

    <section class="content">
        <div *ngIf="isFilterVisible" class="row">
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="trip-id-filter" class="background-white radius-5">
                    <ng-multiselect-dropdown-angular7
                        id="tripId"
                        placeholder="Trip ID"
                        [settings]="getTripIdDataModel.tripIdDropdownSettings"
                        [data]="getTripIdDataModel.tripIdList"
                        [(ngModel)]="getTripIdDataModel.selectedTripIdList"
                        (onDeSelect)="filterGroupChatList()"
                        (onSelect)="filterGroupChatList()"
                    >
                    </ng-multiselect-dropdown-angular7>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="customer-filter" class="background-white radius-5">
                    <ng-multiselect-dropdown-angular7
                        id="customerName"
                        placeholder="Customer"
                        [settings]="getCustomerDataModel.customerDropdownSettings"
                        [data]="getCustomerDataModel.customerList"
                        [(ngModel)]="getCustomerDataModel.selectedCustomerList"
                        (onDeSelect)="filterGroupChatList()"
                        (onSelect)="filterGroupChatList()"
                    >
                    </ng-multiselect-dropdown-angular7>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="group-name-filter">
                    <input
                        id="groupName"
                        class="form-control"
                        name="groupName"
                        placeholder="Filter by Group Name"
                        type="text"
                        [value]="groupNameFilterText"
                        [(ngModel)]="groupNameFilterText"
                        (keyup)="filterGroupChatList()"
                    />
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 pb-4">
                <div id="message-filter">
                    <input id="message" class="form-control" name="message" placeholder="Filter by Message" type="text" />
                </div>
            </div>
        </div>

        <div class="row">
            <app-chat-list
                [accessingFrom]="'page'"
                [internalMemberList]="internalMemberList"
                [sRListGroupList]="filteredSRListGroupList"
                (totalUnreadMessagesCount)="showTotalUnreadMessageCount($event)"
            ></app-chat-list>
            <app-message-panel [internalMemberList]="internalMemberList"></app-message-panel>
        </div>
    </section>
</div>
